// Helpers to open native map / calendar apps from a job

// Compute the effective total for a job — mirrors backend/effective_income + JobDialog logic.
// Uses stored total_payment when > 0, otherwise labor (actual > estimated) + extras.
export const effectiveTotal = (job) => {
  if (!job) return 0;
  const manual = parseFloat(job.total_payment) || 0;
  if (manual > 0) return manual;
  const laborA = (parseFloat(job.actual_hourly_rate) || 0) * (parseFloat(job.actual_hours) || 0);
  const laborE = (parseFloat(job.hourly_rate) || 0) * (parseFloat(job.estimated_hours) || 0);
  const labor = laborA > 0 ? laborA : laborE;
  const extras = (job.extra_charges || []).reduce((s, x) => s + (parseFloat(x.amount) || 0), 0);
  return labor + extras;
};


export const openInMaps = (address) => {
  if (!address) return;
  const q = encodeURIComponent(address);
  // Universal Google Maps URL — opens native app on iOS/Android if installed, browser otherwise
  const url = `https://www.google.com/maps/search/?api=1&query=${q}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

export const openDirections = (from, to) => {
  if (!to) return;
  const origin = from ? `&origin=${encodeURIComponent(from)}` : "";
  const url = `https://www.google.com/maps/dir/?api=1${origin}&destination=${encodeURIComponent(to)}`;
  window.open(url, "_blank", "noopener,noreferrer");
};

const pad2 = (n) => String(n).padStart(2, "0");

// Build a "floating" local datetime string YYYYMMDDTHHmmss (no timezone) — Google Calendar treats
// it as the user's local time, which matches how the app stores date + start_time / end_time.
const toGCal = (dateISO, hhmm) => {
  const [y, m, d] = (dateISO || "").split("-").map(Number);
  const [hh, mm] = (hhmm || "09:00").split(":").map(Number);
  if (!y || !m || !d) return null;
  return `${y}${pad2(m)}${pad2(d)}T${pad2(hh || 0)}${pad2(mm || 0)}00`;
};

export const buildGoogleCalendarUrl = (job) => {
  if (!job) return null;
  const start = toGCal(job.date, job.start_time || "09:00");
  const end = toGCal(job.date, job.end_time || job.start_time || "10:00");
  if (!start || !end) return null;

  const title = `${job.client_name || "Job"}${job.service_type ? " — " + job.service_type : ""}`;

  const detailsLines = [
    job.service_type && `Service: ${job.service_type}`,
    job.contact && `Contact: ${job.contact}`,
    job.address_from && `From: ${job.address_from}`,
    job.address_to && `To: ${job.address_to}`,
    job.total_payment && `Total: $${Number(job.total_payment).toFixed(2)}`,
    job.deposit && `Deposit: $${Number(job.deposit).toFixed(2)}`,
    job.notes && `\nNotes: ${job.notes}`,
    `\n— Flores On The Move`,
  ].filter(Boolean).join("\n");

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title,
    dates: `${start}/${end}`,
    details: detailsLines,
    location: job.address_to || job.address_from || "",
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const syncToGoogleCalendar = (job) => {
  const url = buildGoogleCalendarUrl(job);
  if (url) window.open(url, "_blank", "noopener,noreferrer");
};
